import type { MRT_ColumnDef, MRT_RowData } from "mantine-react-table-open";
import { RequiredGenerationShareLinkCell } from "../../../../../components/Direktvermarktung/DirektvermarktungContractInformation/DirektvermarktungGeneratorShareTable/Columns/RequiredGenerationShareLinkCell";
import type { ColumnDefinitionProps } from "../../../../../mantine/mrt/components/columns/columns.types";

interface GetWeightingColumnProps<
  T extends MRT_RowData
> extends ColumnDefinitionProps<T> {
  siteIdKey?: Extract<keyof T, string>;
}

export function getWeightingColumn<T extends MRT_RowData>({
  key,
  siteIdKey = "site" as Extract<keyof T, string>,
  options
}: GetWeightingColumnProps<T>): MRT_ColumnDef<T> {
  return {
    header: "Einspeisezeitreihe: Anteil",
    accessorKey: key,
    sortingFn: "alphanumeric",
    enableEditing: false,
    Cell: ({ row, renderedCellValue }) => (
      <RequiredGenerationShareLinkCell
        missingValueText="Aufteilungsfaktor eintragen"
        renderedCellValue={renderedCellValue}
        siteId={row.original[siteIdKey] as number | string | null | undefined}
        tooltip="Zu den Erzeugungsanteilen"
      />
    ),
    ...options
  };
}
